import { AuthService } from '@anecdotes/auth-core';
import { Injectable } from '@angular/core';
import { createEffect } from '@ngrx/effects';
import { distinctUntilChanged, filter, map, switchMap } from 'rxjs';
import { UserFlowInitializer } from '../../../services/external-services';
import { WindowHelperService } from '@anecdotes/utils';

@Injectable()
export class UserflowEffects {
  constructor(
    private userflowInitializer: UserFlowInitializer,
    private authService: AuthService,
    private windowHelper: WindowHelperService
  ) {}

  identifyUser$ = createEffect(
    () =>
      this.authService.getUser().pipe(
        map((user) => !!user),
        distinctUntilChanged(),
        filter((isAuthenticated) => isAuthenticated),
        switchMap(() => this.userflowInitializer.identifyUserAsync())
      ),
    { dispatch: false }
  );

  identifyAnonymous$ = createEffect(
    () =>
      this.authService.getUser().pipe(
        map((user) => !!user),
        filter(() => !this.windowHelper.getLocation().pathname.startsWith('/auth')),
        distinctUntilChanged(),
        filter((isAuthenticated) => !isAuthenticated),
        switchMap(() => this.userflowInitializer.identifyAnonymousAsync())
      ),
    { dispatch: false }
  );
}
